import { Heading, IconButton } from '@launchpad-ui/components';

import styles from '../SaveChangesModal.module.css';

type HeaderProps = {
  headerText?: string;
  onClose?: () => void;
};

export function Header({ headerText = 'Save changes', onClose }: HeaderProps) {
  return (
    <div slot="header">
      <div className={styles.header}>
        <div className={styles.titleWrapper} title={headerText}>
          <Heading data-test-id="save-changes-confirm-modal-title" slot="title">
            {headerText}
          </Heading>
        </div>
        {onClose && <IconButton aria-label="close modal" icon="cancel" variant="minimal" onPress={onClose} />}
      </div>
    </div>
  );
}
